/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
* Author:
*/

import type { SVGProps } from 'react'

export default function Sort(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 2.5C6.29354 2.50003 6.66667 2.87312 6.66667 3.33333V14.6549L8.57747 12.7441C8.90291 12.4187 9.43043 12.4187 9.75586 12.7441C10.0813 13.0696 10.0813 13.5971 9.75586 13.9225L6.42253 17.2559C6.38375 17.2946 6.34054 17.3286 6.29476 17.3592C6.26215 17.381 6.22857 17.4003 6.19385 17.417C6.15594 17.4352 6.11668 17.451 6.07585 17.4634C6.0619 17.4676 6.04764 17.4705 6.03353 17.474C6.02053 17.4772 6.0077 17.4811 5.99447 17.4837C5.98855 17.4849 5.98249 17.4851 5.97656 17.4862C5.92995 17.4943 5.88226 17.5 5.83333 17.5L5.74788 17.4959C5.72998 17.4941 5.71253 17.4899 5.69499 17.487C5.68632 17.4855 5.67757 17.4846 5.66895 17.4829C5.65936 17.481 5.64993 17.4786 5.64046 17.4764C5.62332 17.4723 5.6061 17.4685 5.58919 17.4634C5.54865 17.451 5.50966 17.4352 5.47201 17.417C5.43884 17.401 5.4064 17.3831 5.37516 17.3625C5.32795 17.3313 5.28398 17.2957 5.24414 17.2559L1.91081 13.9225C1.58537 13.5971 1.58537 13.0696 1.91081 12.7441C2.23625 12.4187 2.76377 12.4187 3.08919 12.7441L5 14.6549V3.33333C5 2.8731 5.3731 2.5 5.83333 2.5ZM12.5 9.16667C12.9602 9.1667 13.3333 9.53978 13.3333 10C13.3333 10.4602 12.9602 10.8333 12.5 10.8333H9.16667C8.70643 10.8333 8.33333 10.4602 8.33333 10C8.33333 9.53976 8.70643 9.16667 9.16667 9.16667H12.5ZM15 5.83333C15.4602 5.83337 15.8333 6.20645 15.8333 6.66667C15.8333 7.12688 15.4602 7.49997 15 7.5H9.16667C8.70643 7.5 8.33333 7.1269 8.33333 6.66667C8.33333 6.20643 8.70643 5.83333 9.16667 5.83333H15ZM17.5 2.5C17.9602 2.50003 18.3333 2.87312 18.3333 3.33333C18.3333 3.79355 17.9602 4.16663 17.5 4.16667H9.16667C8.70643 4.16667 8.33333 3.79357 8.33333 3.33333C8.33333 2.8731 8.70643 2.5 9.16667 2.5H17.5Z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  )
}
